import * as React from 'react';
const PiagheDaDecubitoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M135.56 109.01c-9.25 4.86-20.4-2.15-19.97-8.46.44-6.5 4.75-4.86 4.69-9.66s-2.72-10.75 2.72-11.72c1.61-.29 3.05.43 4.28 1.7"
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
    <path
      d="M125.13 59.17V73.3c0 6.41 10.99 18.32 10.99 36.12 0 15.05-3.14 31.41-3.14 31.41M74.87 59.17V73.3c0 6.41-10.99 18.32-10.99 36.12 0 15.05 3.14 31.41 3.14 31.41M85.87 128.27c6.02 0 14.13-1.57 14.13-18.85 0 17.28 8.11 18.85 14.13 18.85M100 109.42v-3.14M103.14 123.37v17.46M96.86 123.37v17.46"
      className="prefix__cls-2"
    />
  </svg>
);
export default PiagheDaDecubitoIcon;
